module.exports = __webpack_public_path__ + "static/img/3_3_2.fc7440c2.png";